import { createClient } from '../prismicio';
import * as prismic from '@prismicio/client';
import { getSearchSSP } from '../lib/getServerSideProps';
import SearchPageComponent from '../components/SearchPage';
import { PAGE_SIZE } from '../constants';

const NewsIndex = (props) => {
  return <SearchPageComponent {...props} />;
};

export default NewsIndex;

const _getServerSideProps = getSearchSSP();

export async function getServerSideProps({ locale, previewData, query }) {
  const client = createClient({ previewData });
  const opts = { lang: locale };
  const predicates = [];

  const pageType = query.type;
  const page = query.page || 1;
  let orderings = ['my.page.publication_date'];
  let queryPageType = pageType;
  let tags = query.tags?.split(',') || [];
  let country = query.country;
  let q = query.q;

  // News is actually pages with the News tag
  if (pageType === 'news') {
    queryPageType = 'page';
    tags = tags.length > 0 ? tags : ['News'];
    // Projects are sorted by year
  } else if (pageType === 'project') {
    orderings = ['my.project.year'];
    // Publications are sorted by publication year
  } else if (pageType === 'publication') {
    orderings = ['my.publication.year'];
    // Full text search
  } else if (pageType === 'page') {
    orderings = ['my.page.publication_date', 'my.project.year'];
    queryPageType = null;
  }

  // Only page and publication support tags
  if (['page', 'publication'].includes(queryPageType) && tags.length > 0) {
    // If there are tags, fetch ids of the tags to feed in to the relationship
    // field. We need to get the id of the document in order to query instead
    // of using the tag name directly in the predicates.
    if (tags.length > 0) {
      const { results } = await client.get({
        predicates: [prismic.predicate.any('my.tag.name', tags)],
        pageSize: 100,
        ...opts
      });
      const tagIds = results.map((item) => item.id);
      predicates.push(
        prismic.predicate.any(`my.${queryPageType}.tags.tag`, tagIds)
      );
    }
  }

  // Only project and publication support country
  if (['project', 'publication'].includes(queryPageType) && country) {
    predicates.push(
      prismic.predicate.any(`my.${queryPageType}.countries.code`, [country])
    );
  }

  // either single page type, or all real pages
  if (queryPageType) {
    predicates.push(prismic.predicate.any('document.type', [queryPageType]));
  } else {
    predicates.push(
      prismic.predicate.any('document.type', ['page', 'project', 'programme'])
    );
  }
  // exclude hidden pages
  predicates.push(prismic.predicate.not('document.tags', ['hidden']));
  predicates.push(prismic.predicate.not('document.tags', ['Hidden']));

  // fulltext search
  if (q) {
    predicates.push(prismic.predicate.fulltext('document', q));
  }

  return _getServerSideProps({
    params: {
      predicates,
      page,
      pageSize: query?.per_page || PAGE_SIZE,
      orderings: orderings.map((field) => ({ field, direction: 'desc' }))
    },
    locale,
    previewData
  });
}
